import React, { Component } from 'react';
import './CamErrorScreen.css';
import { withTranslation } from "react-i18next";
import { FiCameraOff } from 'react-icons/fi';
//import log from './utils';

class CamErrorScreen extends Component {
    render() {
        const { t } = this.props;
        return (
            <div className="CamErrorScreen">
                <FiCameraOff className="CamOffIcon" />
                <h1>{t('Błąd połączenia z kamerą')}</h1>
                <p>{t('Upewnij się, że')}:</p>
                <ul>
                    <li>{t('Twoje urządzenie posiada działającą kamerę i mikrofon')}</li>
                    <li>{t('Przeglądarka internetowa ma dostęp do kamery oraz mikrofonu')}</li>
                    <li>{t('Kamera oraz mikrofon nie są używane przez inną aplikację na urządzeniu')}</li>
                </ul>
                <p>{t('Następnie naciśnij start.')}</p>
                <button onClick={this.props.handleStartButtonClick}>{t('Start')}</button>
            </div>
        );
    }
}

export default withTranslation()(CamErrorScreen);
